import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from "@auth0/auth0-angular";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {COMPANY_NAME_MAX_CHARS, Order} from "../../model/order";
import {OrderService} from "../../service/order.service";
import {NgIf} from "@angular/common";
import {MatOption, MatSelect} from "@angular/material/select";
import {
  MatDialogContent,
  MatDialogRef
} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-internal-order-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    MatSelect,
    MatOption,
    MatDialogContent
  ],
  templateUrl: './internal-order-form.component.html',
  styleUrl: './internal-order-form.component.css'
})
export class InternalOrderFormComponent implements OnInit {
  private readonly SNACKBAR_DURATION = 5000;

  private authService = inject(AuthService);
  private orderService = inject(OrderService);
  private formBuilder = inject(FormBuilder);
  private snackBar = inject(MatSnackBar);
  public dialogRef = inject(MatDialogRef<InternalOrderFormComponent>);

  orderForm: FormGroup = this.createForm();
  userEmail: string | null = null;

  prevent(event: any) {
    event.preventDefault();
  }

  cancel() {
    this.dialogRef.close();
  }

  submit() {
    const order = new Order();

    order.orderType = this.orderType?.value;
    order.companyName = this.companyName?.value;
    order.creatorEmail = this.userEmail;

    this.orderService.createInternalOrder(order).subscribe({
      next: value => {
        if (!value || !value.ok) {
          this.snackBar.open("Error creating order.", undefined, {
            duration: this.SNACKBAR_DURATION});
        }

        this.dialogRef.close();
      }
    });
  }

  private createForm(): FormGroup {
    return this.formBuilder.group({
      companyName: [null, [Validators.required, Validators.maxLength(COMPANY_NAME_MAX_CHARS)]],
      orderType: [null, [Validators.required]]
    });
  }

  get companyName() {
    return this.orderForm.get('companyName');
  }

  get orderType() {
    return this.orderForm.get('orderType');
  }

  ngOnInit() {
    this.authService.user$.subscribe(user => {
      this.userEmail = user!.email!;
    });
  }

  protected readonly COMPANY_NAME_MAX_CHARS = COMPANY_NAME_MAX_CHARS;
}
